import { render, staticRenderFns } from "./BidReports.vue?vue&type=template&id=6c003007&scoped=true&"
import script from "./BidReports.vue?vue&type=script&lang=js&"
export * from "./BidReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c003007",
  null
  
)

export default component.exports